import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import EventNoteIcon from '@mui/icons-material/EventNote'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'

interface Props {
  value: string
  onClick: () => void
}
const CustomInput: FC<Props> = ({ value, onClick }) => {
  const { t } = useTranslation()

  return (
    <InputBase
      onClick={onClick}
      value={value}
      readOnly
      placeholder={t('payment.dateHolder')}
      sx={{
        fontSize: '1rem',
        fontWeight: '200',
        color: 'white',
        textAlign: 'left',
        backgroundColor: 'transparent',
        width: '160%',
        paddingRight: '2rem',
        marginBottom: '2rem',
        borderBottom: '1px solid white',
      }}
      endAdornment={
        <IconButton sx={{ position: 'absolute', right: 0, bottom: 1, color: 'white' }}>
          <EventNoteIcon />
        </IconButton>
      }
    />
  )
}

export default CustomInput
